if (!customElements.get("media-gallery")) {
  customElements.define(
    "media-gallery",
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.baseURL = window.globalConfig?.cdnFileUrl;
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia("(min-width: 750px)");

        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener(
          "slideChanged",
          debounce(this.onSlideChanged.bind(this), 500)
        );
        this.elements.thumbnails
          .querySelectorAll("[data-target]")
          .forEach((mediaToSwitch) => {
            mediaToSwitch
              .querySelector("button")
              .addEventListener(
                "click",
                this.setActiveMedia.bind(
                  this,
                  mediaToSwitch.dataset.target,
                  false
                )
              );
          });
        if (
          this.dataset.desktopLayout.includes("thumbnail") &&
          this.mql.matches
        )
        this.removeListSemantic();

        // Update Main Image for metafield Image
        this.updateMainImageSrc();

        // Hide dynamicMetafieldVariantImage initially if there's no metafield value
        this.checkMetafieldAndToggleVisibility();
      }

      // Helper method to get current dynamic metafield elements
      getDynamicMetafieldElements() {
        return {
          desktop: document.querySelector("#variant__dynamic-metafield-image"),
          mobile: document.querySelector("#variant__dynamic-metafield-image-mobile")
        };
      }

      onSlideChanged(event) { 
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector("[data-media-id]");

        if (!activeMedia) {
          return;
        }

        this.elements.viewer.querySelectorAll("[data-media-id]").forEach((element) => {
          element.classList.remove("is-active");
        });

        activeMedia?.classList?.add("is-active");

        if (prepend) {
          // Get references to dynamic metafield elements
          const { desktop: dynamicMetafieldVariantImageDesktop, mobile: dynamicMetafieldVariantImageMobile } = this.getDynamicMetafieldElements();
          const hiddenVariantID = document.querySelector("#hidden-variant-id");
          const thumbnailParentDesktop = dynamicMetafieldVariantImageDesktop?.closest("li");
          const thumbnailParentMobile = dynamicMetafieldVariantImageMobile?.closest("li");

          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);
          
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(
              `[data-target="${mediaId}"]`
            );
            
            if (activeThumbnail && hiddenVariantID) {
              activeThumbnail.setAttribute("data-dynamic-variant", hiddenVariantID.innerText);
            }

            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);

            if (dynamicMetafieldVariantImageDesktop || dynamicMetafieldVariantImageMobile) {
              let thumbUrl = window.variantMetafields[hiddenVariantID.innerText]?.variant_image_2_filename;
          
              const varAltText = Object.values(window.variantMetafields).filter(u => (u.variant_image_2_filename == thumbUrl)).map(u => u.variant_img_alt);

              if (thumbUrl && !thumbUrl.includes(".jpg") && !thumbUrl.includes(".jpeg")) {
                thumbUrl += ".jpg";
              }
              
              const imageUrl = this.baseURL + thumbUrl;

              if (this.mql.matches) {
                if(thumbUrl) {
                  if (dynamicMetafieldVariantImageDesktop) {
                    dynamicMetafieldVariantImageDesktop.src = imageUrl;
                    dynamicMetafieldVariantImageDesktop.setAttribute('alt', varAltText[0]);
                  }
                  if (thumbnailParentDesktop) thumbnailParentDesktop.style.display = "block";
                } else {
                  if (thumbnailParentDesktop) thumbnailParentDesktop.style.display = "none";
                }
              } else {
                if(thumbUrl) {
                  if (dynamicMetafieldVariantImageMobile) {
                    dynamicMetafieldVariantImageMobile.src = imageUrl;
                    dynamicMetafieldVariantImageMobile.setAttribute('alt', varAltText[0]);
                  }
                  if (thumbnailParentMobile){
                    thumbnailParentMobile.style.display = "block";
                    thumbnailParentMobile.classList.remove('mobileHide');
                  }
                } else {
                  if (thumbnailParentMobile) {
                    thumbnailParentMobile.style.display = "none";
                    thumbnailParentMobile.classList.add('mobileHide');
                  }
                }
              }
            }
          }
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({
              left: activeMedia.offsetLeft,
            });
          }
        });
        this.playActiveMedia(activeMedia);
        
        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${mediaId}"]`
        );
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(
          activeMedia,
          activeThumbnail.dataset.mediaPosition
        );
      }
      
      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll("button")
          .forEach((element) => element.removeAttribute("aria-current"));

        const button = thumbnail.querySelector("button");
        if (button) {
          button.setAttribute("aria-current", true);
        }

        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({
          left: thumbnail.offsetLeft,
        });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector(
          ".product__modal-opener--image img"
        );
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute("aria-hidden", false);
          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace(
              "[index]",
              position
            );
          setTimeout(() => {
            this.elements.liveRegion.setAttribute("aria-hidden", true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector(".deferred-media");
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader || document.querySelector("sticky-header");
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event("preventHeaderReveal"));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute("role", "presentation");
        this.elements.viewer.sliderItems.forEach((slide) =>
          slide.setAttribute("role", "presentation")
        );
      }

      // Update Main Image for metafield Image
      updateMainImageSrc() {
        // Get references each time
        const { desktop: dynamicMetafieldVariantImageDesktop, mobile: dynamicMetafieldVariantImageMobile } = this.getDynamicMetafieldElements();
        const buttonElementDesktop = dynamicMetafieldVariantImageDesktop?.closest("button");
        const buttonElementMobile = dynamicMetafieldVariantImageMobile?.closest("button");
        
        const updateImageSrc = (buttonElement, imageElement) => {
          buttonElement?.addEventListener("click", () => {
            const listEl = document.querySelector("custom-slider-component.product-image li.is-active");
            const mainImageEl = listEl.querySelector(".variant-metafield-image") || listEl.querySelector(".product__media img");
            
            if (mainImageEl) {
              mainImageEl.src = imageElement?.getAttribute("src");
              mainImageEl.setAttribute('alt', imageElement?.getAttribute("alt"));
            }
          });
        };

        updateImageSrc(buttonElementDesktop, dynamicMetafieldVariantImageDesktop);
        updateImageSrc(buttonElementMobile, dynamicMetafieldVariantImageMobile);
      }

      // Check if metafield exists for the current variant
      checkMetafieldAndToggleVisibility() {
        // Get references each time
        const { desktop: dynamicMetafieldVariantImageDesktop, mobile: dynamicMetafieldVariantImageMobile } = this.getDynamicMetafieldElements();
        const hiddenVariantID = document.querySelector("#hidden-variant-id");
        const variantImage = window.variantMetafields[hiddenVariantID?.innerText]?.variant_image_2_filename;

        if (variantImage) {
          let thumbUrl = variantImage;
          if (!thumbUrl.includes(".jpg") && !thumbUrl.includes(".jpeg")) {
            thumbUrl += ".jpg";
          }

          const imageUrl = this.baseURL + thumbUrl;
          if (this.mql.matches) {
            if(dynamicMetafieldVariantImageDesktop) {
              dynamicMetafieldVariantImageDesktop.src = imageUrl;
              dynamicMetafieldVariantImageDesktop.closest("li").style.display = "block";
            }
          } else {
            if(dynamicMetafieldVariantImageMobile) {
              dynamicMetafieldVariantImageMobile.src = imageUrl;
              dynamicMetafieldVariantImageMobile.closest("li").style.display = "block";
              dynamicMetafieldVariantImageMobile.closest("li").classList.remove('mobileHide');
            }
          }
        } else {
          if(dynamicMetafieldVariantImageDesktop) dynamicMetafieldVariantImageDesktop.closest("li").style.display = "none";
          if(dynamicMetafieldVariantImageMobile) {
            dynamicMetafieldVariantImageMobile.closest("li").style.display = "none";
            dynamicMetafieldVariantImageMobile.closest("li").classList.add('mobileHide');
          }
        }
      }
    }
  );
}